import React from 'react';
import PropTypes from 'prop-types';
import {withStore, withScreenCheck} from '../hoc';
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import Body from '../components/Body';
import Footer from '../components/Footer';
import Contact from '../components/Contact';

/**
 * ContactPage
 */
class ContactPage extends React.Component {
  static displayName = 'ContactPage';
  static propTypes = {
    stores: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
    currentPage: PropTypes.object.isRequired,
  };
  static defaultProps = {};

  /**
   * @override
   */
  render() {
    return (
      <div className="Entreprise">
        <Navbar {...this.props} />
        <Header
          {...this.props}
          images={[
            this.props.screen === 'desktop'
              ? this.props.currentPage.heroImage()
              : this.props.currentPage.heroMobileImage(),
          ]}
        >
          {this.props.currentPage.heroCaption()}
        </Header>
        <Body {...this.props}>
          <Contact {...this.props} />
        </Body>
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(ContactPage));



// WEBPACK FOOTER //
// ./src/pages/ContactPage.js